export default "__VITE_ASSET__DXB2tHag__"